export default {
  'label/new_appointment': 'Nueva Cita',
  'action/refresh': 'Actualizar Agenda',
  'action/all_rooms': 'Todas las Salas',
  'label/all_subfilters': 'Todos',
  'label/calendar_day': 'Día',
  'label/calendar_week': 'Semana',
  'label/calendar_today': 'Hoy',
  'label/blocked_time': 'Tiempo Bloqueado',
  'label/hour': 'Hora',
  'action/select_month': 'Selecciona el mes',
  'label/duration': 'Duración',
  'action/hide': 'Eliminar de la Agenda',
  'action/delete_only': 'Eliminar solo este evento',
  'action/delete_future': 'Eliminar todos los eventos futuros',
  'label/date/tomorrow': 'Mañana',
  'label/date/yesterday': 'Ayer',
  'label/title': 'Título',
  'label/whatsApp': 'Confirmar vía WhatsApp',
  'label/online/menu_on': 'Consulta en línea',
  'label/online/menu_off': 'Consulta presencial',
  'label/online/title': 'Consulta en línea',
  'label/online/toggle': 'Consulta en línea',
  'label/online/link': 'Enlace de la llamada',
  'label/online/own_link': 'El paciente recibe este enlace en lugar del enlace fijo de la sala.',
  'label/online/uses_doctor_link': 'En blanco, vale el enlace fijo de la sala del profesional:',
  'label/online/no_link': 'Pegue el enlace de la llamada (Google Meet, Zoom, WhatsApp...) o registre el enlace fijo de la sala en Configuraciones › Doctores.',
  'label/online/google_meet': 'Al guardar, Doutore crea un enlace propio de Google Meet para esta consulta.',
  'label/online/google_meet_placeholder': 'Enlace de Google Meet creado al guardar',
  'label/online/google_title': 'Enlace de Google Meet automático',
  'label/online/google_connect': 'Conecta tu Google Calendar y ya no tendrás que pegar enlaces: cada consulta en línea recibe un enlace propio de Google Meet al guardar, y tus consultas aparecen en Google Calendar, en el celular y en la computadora.',
  'label/online/google_reconnect': 'Se perdió la conexión con Google Calendar: se quitó el acceso o se borró el calendario “Doutore”. Conéctalo de nuevo para que el enlace de Google Meet vuelva a crearse solo.',
  'label/online/google_opened': 'Inicia sesión con tu cuenta de Google en la página que se abrió y vuelve aquí: el enlace se creará al guardar.',
  'label/online/google_doctor': 'Cuando {{doctor}} conecte Google Calendar en su propia cuenta, en Configuraciones › Google Calendar, cada consulta en línea recibirá un enlace propio de Google Meet al guardar.',
  'label/online/google_doctor_unnamed': 'Cuando el profesional conecte Google Calendar en su propia cuenta, en Configuraciones › Google Calendar, cada consulta en línea recibirá un enlace propio de Google Meet al guardar.',
  'label/online/google_until_then': 'Mientras tanto, pega el enlace aquí.',
  'action/online/connect_google': 'Conectar Google Calendar',
  'label/online/patient_gets_link': 'En la confirmación por WhatsApp, el paciente ve "consulta en línea" y el enlace de la llamada en lugar de la dirección.',
  'action/online/join': 'Entrar a la llamada',
  'action/online/join_short': 'Llamada',
  'error/online/invalid_link': 'Enlace no válido. Pegue la dirección completa, como https://meet.google.com/abc-defg-hij',
  'label/sendMessage': 'Enviar mensaje',
  'label/contracted_services': 'Servicios Contratados',
  'label/show_obs': 'Mostrar observaciones en el expediente',
  'label/status/scheduled': 'Cita programada',
  'label/status/sms_sent': 'SMS enviado',
  'label/status/sms_confirmed': 'Confirmada por el paciente',
  'label/status/sms_canceled': 'Cancelada por el paciente',
  'label/status/confirmed': 'Cita confirmada',
  'label/status/patient_arrived': 'Paciente llegó',
  'label/status/patient_attended': 'Paciente atendido',
  'label/status/patient_missed': 'Paciente faltó',
  'label/status/patient_canceled': 'Paciente canceló',
  'label/status/canceled_by_doctor': 'Consultorio canceló',
  // An appointment's status in one word, on the agenda
  'label/badge/confirmed': 'Confirmada',
  'label/badge/arrived': 'Llegó',
  'label/badge/completed': 'Atendida',
  'label/badge/missed': 'Faltó',
  'label/badge/canceled': 'Cancelada',
  'label/badge/scheduled': 'Programada',
  // The appointment form's rows: what each shows (the field's name while empty)
  'label/row/recurrence/none': 'Repetir cita',
  'label/row/recurrence/none_block': 'Repetir horario',
  'label/row/recurrence/other': 'Recurrente',
  'label/row/recurrence/appointments': 'citas',
  'label/row/recurrence/appointments_one': 'cita',
  'label/row/recurrence/blocks': 'horarios',
  'label/row/recurrence/blocks_one': 'horario',
  'label/row/status_at': 'DD/MM [a las] HH:mm',
  'label/change_status': 'Cambiar status',
  // The status screen: what happened to the appointment, and what can still happen
  'label/status/timeline': 'Historial',
  'label/status/update': 'Actualizar status',
  'action/status/undo': 'Deshacer',
  'format/status_date': 'DD/MMM [a las] HH:mm',
  'label/status/stays/missed': 'Estos entran en el historial, pero el status sigue "Faltó".',
  'label/status/stays/canceled': 'Estos entran en el historial, pero el status sigue "Cancelada".',
  'action/status/history': 'Historial de cambios',
  'action/status/history_label': 'Historial de cambios, se abre en el Panel de Control',
  'label/services/empty_edit': 'Esta cita no tiene servicios',
  'label/services/empty_new': 'Ningún servicio registrado',
  'label/services/empty_new_hint': 'Registre los servicios en Configuraciones › Tabla de Servicios. Aparecen aquí para elegir en la cita y cargar en las finanzas del paciente.',
  'label/services/empty_search': 'Ningún servicio encontrado para esta búsqueda',
  'label/services/recents': 'Más Recientes',
  'label/services/private': 'Particular',
  'label/services/health_plan': 'Plan de Salud',
  'label/services/loading': 'Cargando servicios',
  'action/services/add_services': 'Agregar servicios',
  'label/patient_vip': 'Paciente con Gratuidad',
  'label/services/service_list': 'Lista de Servicios',
  'action/services/view_selected_services': 'Ver todos los servicios seleccionados',
  'label/rooms/select_one_room': 'Selecciona una sala',
  'label/recurrency/recurrent_appointment': 'Cita recurrente',
  'label/recurrency/none': 'No se repite',
  'label/recurrency/weekly': 'Cada semana',
  'label/recurrency/weekly_hint': 'En uno o más días de la semana',
  'label/recurrency/biweekly': 'Cada 2 semanas',
  'label/recurrency/biweekly_hint': '{0} sí, {1} no',
  'label/recurrency/days': 'Días de la semana',
  'label/recurrency/short/monday': 'Lun',
  'label/recurrency/short/tuesday': 'Mar',
  'label/recurrency/short/wednesday': 'Mié',
  'label/recurrency/short/thursday': 'Jue',
  'label/recurrency/short/friday': 'Vie',
  'label/recurrency/short/saturday': 'Sáb',
  'label/recurrency/short/sunday': 'Dom',
  'label/recurrency/pick_a_day': 'Elige al menos un día de la semana.',
  'label/recurrency/count': 'Número de citas',
  'label/recurrency/count_blocked': 'Número de horarios',
  'action/recurrency/fewer': 'Menos',
  'action/recurrency/more': 'Más',
  'label/recurrency/summary': 'Son {0} citas, del {1} al {2}.',
  'label/recurrency/summary_blocked': 'Son {0} horarios bloqueados, del {1} al {2}.',
  'label/recurrency/starts_later': 'La serie empieza el primer día marcado, no el {0}.',
  'label/recurrency/series': 'Forma parte de una serie de {0} citas.',
  'label/recurrency/series_blocked': 'Forma parte de una serie de {0} horarios bloqueados.',
  'label/recurrency/delete_all_future_events': 'Eliminar esta y las próximas citas',
  'label/recurrency/delete_all_future_blocked': 'Eliminar este y los próximos horarios',
  'label/doctor_select/title': 'Selecciona un Doctor',
  'label/doctor_select/loading': 'Cargando doctores',
  'label/patient_select/add_patient': 'Registrar nuevo paciente',
  'label/patient_select/search_patient': 'Buscar paciente',
  'label/patient_select/search_all_patients': 'Todos los pacientes',
  'label/patient_select/reschedule_patients': 'Pacientes con etiqueta para reprogramar',
  'label/patient_select/loading': 'Cargando pacientes',
  'label/patient_select/suggested': 'Pacientes sugeridos',
  'label/patient_select/incomplete_list': '* Esta lista de pacientes está incompleta: para encontrar otros pacientes, escribe el nombre en "Buscar paciente"',
  'label/patient_form/name': 'Nombre',
  'label/patient_form/birthdate': 'Fecha de nacimiento',
  'label/patient_form/cpf': 'CPF',
  'label/patient_form/legalId': 'Identidad',
  'label/patient_form/mobile_phone': 'Teléfono Móvil',
  'label/patient_form/email': 'E-mail',
  'label/patient_form/recommended_by': 'Recomendación',
  'label/patient_form/profession': 'Profesión',
  'label/patient_form/placeOfBirth': 'Lugar de nacimiento',

  'label/patient_form/maritalStatusCode': 'Estado Civil',
  'label/patient_form/doctorId': 'Responsable',
  'label/patient_form/medic': 'Médico',
  'label/patient_form/mobilePhone': 'Teléfono Móvil',
  'label/patient_form/homePhone': 'Teléfono Fijo',
  'label/patient_form/otherPhone': 'Teléfono Adicional',
  'label/patient_form/father': 'Padre',
  'label/patient_form/mother': 'Madre',
  'label/patient_form/guardianName': 'Responsable',
  'label/patient_form/guardianRelationship': 'Parentesco',
  'label/patient_form/insuranceCompany': 'Seguro',
  'label/patient_form/insurancePlan': 'Plan',
  'label/patient_form/insuranceNumber': 'Número de Póliza',
  'label/patient_form/insuranceExpirationDate': 'Fecha de Vencimiento',

  'label/patient_form/insurance_plan': 'Plan de Salud',
  'label/patient_form/title': 'Nuevo Paciente',
  'label/patient_info/title': 'Resumen del registro',
  'label/patient_info/responsible': 'Responsable',
  'label/patient_info/other_phone': 'Teléfono Adicional',
  'label/patient_info/select_another': 'Seleccionar otro paciente',
  'label/patient_info/missing': 'Falta en el registro',
  'label/patient_info/address': 'Dirección',
  'action/patient_info/open_profile': 'Abrir registro',
  'label/patient_info/link_title': 'Registro hecho por el paciente',
  'label/patient_info/link_text': 'El propio paciente puede completar su registro desde el celular: nacimiento, documento, dirección y contacto. Lo que guarde actualiza este registro.',
  'label/patient_info/link_step_open': 'Abre la página del enlace, en el navegador.',
  'label/patient_info/link_step_send': 'Allí, genera el enlace y envíalo por WhatsApp o cópialo.',
  'label/patient_info/link_step_expires': 'El enlace vale hasta que el paciente guarde el registro.',
  'action/patient_info/open_link_page': 'Abrir página del enlace',
  'label/patient_info/link_after_save': 'Guarda la cita para abrir la página del enlace.',
  'label/appointment_with': 'Cita con',
  'label/appointment_sms_canceled': 'Cita cancelada por el paciente',
  'label/appointment_patient_msg': 'Paciente dejó un mensaje',

  'label/patient_form/patient_code': 'Código',

  'action/click_to_create_appointment_at': 'Haz clic para crear una cita a las',
  'action/click_to_create_appointment': 'Haz clic para crear una cita',
  'label/calendar_month': 'Mes',
  'label/no_appointments': 'No hay citas programadas',
  'label/agenda_load_failed': 'No se pudo cargar la agenda. Toca ↻ para intentarlo de nuevo.',
};
